import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import * as SolicitudViaticoService from '../../axios_services/viaticosolicitud.service';

const ModalValidarSolicitudViatico = ({ isOpen, onClose, onRefresh, solicitud, accion }) => {
    const [detalle, setDetalle] = useState('');
    const [loading, setLoading] = useState(false);

    const isAprobacion = accion === 2 || accion === 4;

    useEffect(() => {
        if (isOpen && solicitud) {
            setDetalle(solicitud.detalle || '');
        }
    }, [isOpen, solicitud]);

    const handleValidar = async () => {
        if (!window.confirm(`¿Confirma que desea ${isAprobacion ? 'aprobar' : 'rechazar'} esta solicitud?`)) return;
        setLoading(true);
        try {
            await SolicitudViaticoService.validarSolicitud({
                solicitud_id: solicitud.solicitud_id,
                accion: accion,
                detalle: detalle
            });
            onRefresh();
            onClose();
        } catch (error) {
            console.error(error);
            alert(error.response?.data?.error || 'Error al procesar la solicitud');
        } finally {
            setLoading(false);
        }
    };

    if (!solicitud) return null;

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>{isAprobacion ? 'APROBAR SOLICITUD' : 'RECHAZAR SOLICITUD'}</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={e => e.preventDefault()}>

                        <FormGroup style={{ gridColumn: '1 / -1' }}>
                            <Label>Colaborador:</Label>
                            <Input
                                className="form-control"
                                type="text"
                                value={solicitud?.nombre_empleado || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup style={{ gridColumn: '1 / -1' }}>
                            <Label>Observación:</Label>
                            <Input
                                className="form-control"
                                type="textarea"
                                rows="3"
                                value={detalle}
                                onChange={(e) => setDetalle(e.target.value)}
                                placeholder="Escriba alguna observación (opcional)"
                            />
                        </FormGroup>

                        <FormGroup style={{ marginTop: '18px', gridColumn: '1 / -1' }}>
                            <div className="button-container">
                                <Button
                                    className="button-custom"
                                    onClick={handleValidar}
                                    disabled={loading}
                                >
                                    {loading ? 'PROCESANDO...' : 'REGISTRAR'}
                                </Button>
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalValidarSolicitudViatico;
